export class ResponseSuccess {
    constructor(public status: string, public message: string){}
}